<div class="content-header">
  <h2>
    {{ headerText | translate }}
    <small>
      {{ subHeaderText | translate }}
    </small>
  </h2>
  <a class="help-link-to-registration-info" href="/upload/docs/reg.pdf" target="_blank">
    {{ "Pages.RegistrationByPhone.HelpLinkToRegistrationInfo" | translate }}
  </a>
</div>
